import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_30px_rgba(0,0,0,0.1)] z-50 p-4 md:hidden transform transition-transform duration-300 translate-y-0" data-id="element-75">
      <div className="flex items-center justify-between max-w-md mx-auto" data-id="element-76">
        <div className="flex flex-col" data-id="element-77">
          <span className="text-xs font-bold text-coral mb-0.5" data-id="element-78">
            🔥 Oferta termina pronto
          </span>
          <div className="flex items-baseline gap-2" data-id="element-79">
            <span className="text-xs text-text-medium line-through" data-id="element-80">
              $41.000
            </span>
            <span className="text-xl font-black text-coral-dark" data-id="element-81">$14.999</span>
          </div>
        </div>
        <div className="flex flex-col items-center" data-id="element-82">
          <a href="https://reiniciatumetabolismo.lat/cart/43809396064391:1?checkout" className="flex items-center justify-center px-6 py-3 text-sm font-bold text-white bg-coral rounded-full shadow-cta animate-pulse-soft w-full" data-id="element-83">
            ¡Quiero empezar!
            <ArrowRightIcon className="ml-1" size={16} data-id="element-84" />
          </a>
          <span className="text-[10px] text-text-light mt-1" data-id="element-85">
            ⭐ 4.8/5 · +3.000 mujeres
          </span>
        </div>
      </div>
    </div>;
}